import React, { useContext, useEffect, useState } from "react";
import {
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Table,
  Typography,
  ConfigProvider,
  Radio,
  Tree,
} from "antd";
import LK_Delete from "../../../../images/LK_Delete";
import "../../../../cssfiles/homepage.css";
import CustomCheckbox from "../../../CommonComponents/CustomCheckbox";
import CustomDropDown from "../../../CommonComponents/CustomDropDown";
import CustomTextField from "../../../CommonComponents/CustomTextField";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  Typography as MuiTypography,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import LK_Add from "../../../../images/LK_Add";
import LK_Search from "../../../../images/LK_Search";
import LK_Close from "../../../../images/LK_Close";
import { useSelector } from "react-redux";
import CustomDialogBox from "../../../CommonComponents/CustomDialogBox";
import CustomExportButton from "../../../CommonComponents/CustomExportButton";
import CustomImportButton from "../../../CommonComponents/CustomImportButton";
import { tagdelete } from "../../../../Restclient/datacollection";
import LK_Loading from "../../../../images/LK_Loading.gif";
import CustomTooltip from "../../../CommonComponents/CustomTooltip";
import { ThemeContext } from "../../../../pages/Homepage";
import CustomButton from "../../../CommonComponents/CustomButton";
import CustomRadioButton from "../../../CommonComponents/CustomRadioButton";
import CustomCancelButton from "../../../CommonComponents/CustomCancelButton";
import Chip from "@mui/material/Chip";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";

export default function EditableTable({
  data,
  setdata,
  deviceId,
  _enabled,
  _connstate,
  getdeleteTags,
  units,
  datatypes,
  storageGroupsList,
  virtualDevice,
  tagConfig,
}) {
  const { theme } = useContext(ThemeContext);
  const themeOperate = useSelector((state) => state.themedata.theme);

  const [tabvalue, setTabvalue] = useState("Parameter List");
  const Maintablist = ["Parameter List", "Live Data"];
  const [maintabs, _setMaintabs] = useState(Maintablist);
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [editingKey, setEditingKey] = useState("");
  const [operation, setOperation] = useState(0);
  const [ifsearching, setifSearching] = useState(0);
  const [searchList, setsearchList] = React.useState([]);
  const [search, setSearch] = useState({ searchText: "", filterSelected: "" });
  const filter = [
    "Storage Enabled",
    "Storage Disabled",
    "Active Enabled",
    "Active Disabled",
  ];
  const filterMap = { storage: "Storage", active: "Active" };
  const [deleteTags, setdeleteTags] = useState(0);
  const [ifloading, setifLoading] = useState(0);
  const [required, setRequired] = useState(0);
  const isEditing = (record) => record.key === editingKey;

  // const parameters = data.length>0?data:[{tagId:"",key: 0,parameter: '',description:"",payloadName:"",datatype: '',timestamp: '',alias: '',value:'',unit: '',active: false,storage: false,storageId:[]}]
  const parameters = data.length > 0 ? data : [];
  const [dataSource, setDataSource] = useState(parameters);
  const [activeParameter, setActiveParameter] = useState(parameters);
  const unitsList = units;
  const dataTypesList = datatypes;
  const storageGroups = [
    "none",
    ...storageGroupsList.map((item) => item.GroupName),
  ];

  const livedata = useSelector((state) => state.mainpagedata.livedata);
  const decimalPoints = useSelector(
    (state) => state.mainpagedata.generalConfiguration.decimalPoints,
  );
  const unit0 = unitsList[0] === "NA" ? " " : unitsList[0];
  const [editRow, setEditRow] = useState([
    {
      tagId: "",
      key: 0,
      parameter: "",
      datatype: dataTypesList[0][0],
      description: "",
      alias: "",
      unit: unit0,
      payloadName: "",
      formula: {
        Operation: "",
        Formula: "",
        Operands: [],
      },
      value: "",
      timestamp: "",
      active: false,
      storage: false,
      storageGroupid: "",
      isVirtual: virtualDevice === "true" ? true : false,
      scalingFactor: "",
    },
  ]);

  const [selectedTag, setSelectedTag] = useState(null);
  const [tagType, setTagType] = useState("0");
  const [frequencyOption, setFrequencyOption] = useState("Select Frequency");
  const [disabledFrequency, setDisabledFrequency] = useState([
    "30 Seconds",
    "1 Minute",
    "5 Minutes",
    "15 Minutes",
    "30 Minutes",
    "1 Hour",
    "2 Hours",
    "4 Hours",
    "8 Hours",
    "1 Day",
    "1 Week",
    "1 Month",
    "1 Year",
  ]);
  const [aggregationOption, setAggregationOption] = useState(null);
  const [disabledAggregation, setDisabledAggregation] = useState([
    "SUM",
    "DIFF",
    "AVG",
    "MAX",
    "MIN",
    "SVAL",
    "EVAL",
  ]);
  const [currStorage, setCurrStorage] = useState(null);

  const keyToFrequency = {
    "30SEC": "30 Seconds",
    "1MIN": "1 Minute",
    "5MIN": "5 Minutes",
    "15MIN": "15 Minutes",
    "30MIN": "30 Minutes",
    "1HR": "1 Hour",
    "2HR": "2 Hours",
    "4HR": "4 Hours",
    "8HR": "8 Hours",
    "1DAY": "1 Day",
    "1WEEK": "1 Week",
    "1MONTH": "1 Month",
    "1YEAR": "1 Year",
  };

  const frequencyList = [
    "30 Seconds",
    "1 Minute",
    "5 Minutes",
    "15 Minutes",
    "30 Minutes",
    "1 Hour",
    "2 Hours",
    "4 Hours",
    "8 Hours",
    "1 Day",
    "1 Week",
    "1 Month",
    "1 Year",
  ];

  const operandRules = {
    ADD: { min: 1, max: Infinity },
    SUM: { min: 1, max: Infinity },
    SUBTRACT: { min: 2, max: Infinity },
    MULTIPLY: { min: 1, max: Infinity },
    DIVIDE: { min: 2, max: 2 },
    AVERAGE: { min: 1, max: Infinity },
    MIN: { min: 1, max: Infinity },
    MAX: { min: 1, max: Infinity },
    SQUARE: { min: 1, max: 1 },
    CUBE: { min: 1, max: 1 },
    SQRT: { min: 1, max: 1 },
    POW: { min: 2, max: 2 }, // ← was POWER, renamed to match button value
    ABS: { min: 1, max: 1 },
    LOG: { min: 1, max: 1 },
    LOG10: { min: 1, max: 1 },
    EXP: { min: 1, max: 1 },
    SIN: { min: 1, max: 1 },
    COS: { min: 1, max: 1 },
    TAN: { min: 1, max: 1 },
    MEDIAN: { min: 1, max: Infinity },
    RANGE: { min: 2, max: Infinity },
    STDDEV: { min: 2, max: Infinity },
    FLOOR: { min: 1, max: 1 }, // ← new
    CEIL: { min: 1, max: 1 }, // ← new
    ROUND: { min: 1, max: 1 }, // ← new
  };

  const [operatorOption, setOperatorOption] = useState("Standard");

  const operatorConfig = {
    Standard: [
      [
        { label: "ADD", value: "ADD", isAdv: true },
        { label: "SUM", value: "SUM", isAdv: true },
        { label: "SUBTRACT", value: "SUBTRACT", isAdv: true },
      ],
      [
        { label: "MULTIPLY", value: "MULTIPLY", isAdv: true },
        { label: "DIVIDE", value: "DIVIDE", isAdv: true },
        { label: "AVERAGE", value: "AVERAGE", isAdv: true },
      ],
      [
        { label: "MIN", value: "MIN", isAdv: true },
        { label: "MAX", value: "MAX", isAdv: true },
        { label: "SQUARE", value: "SQUARE", isAdv: true },
      ],
      [
        { label: "CUBE", value: "CUBE", isAdv: true },
        { label: "SQRT", value: "SQRT", isAdv: true },
        { label: "POW", value: "POW", isAdv: true },
      ],
      [
        { label: "ABS", value: "ABS", isAdv: true },
        { label: "LOG", value: "LOG", isAdv: true },
        { label: "LOG10", value: "LOG10", isAdv: true },
      ],
      [
        { label: "EXP", value: "EXP", isAdv: true },
        { label: "SIN", value: "SIN", isAdv: true },
        { label: "COS", value: "COS", isAdv: true },
      ],
      [
        { label: "TAN", value: "TAN", isAdv: true },
        { label: "MEDIAN", value: "MEDIAN", isAdv: true },
        { label: "RANGE", value: "RANGE", isAdv: true },
      ],
      [{ label: "STDDEV", value: "STDDEV", isAdv: true }],
    ],
    Custom: [
      [
        { label: "+", value: "+", isAdv: false },
        { label: "-", value: "-", isAdv: false },
        { label: "*", value: "*", isAdv: false },
      ],
      [
        { label: "/", value: "/", isAdv: false },
        { label: "%", value: "%", isAdv: false },
        { label: "^", value: "^", isAdv: false },
      ],
      [
        { label: "(", value: "(", isAdv: false },
        { label: ")", value: ")", isAdv: false },
        { label: "SQRT", value: "SQRT", isAdv: true },
      ],
      [
        { label: "ABS", value: "ABS", isAdv: true },
        { label: "SIN", value: "SIN", isAdv: true },
        { label: "COS", value: "COS", isAdv: true },
      ],
      [
        { label: "TAN", value: "TAN", isAdv: true },
        { label: "LOG", value: "LOG", isAdv: true },
        { label: "EXP", value: "EXP", isAdv: true },
      ],
      [
        { label: "POW", value: "POW", isAdv: true },
        { label: "MIN", value: "MIN", isAdv: true },
        { label: "MAX", value: "MAX", isAdv: true },
      ],
      [
        { label: "FLOOR", value: "FLOOR", isAdv: true },
        { label: "CEIL", value: "CEIL", isAdv: true },
        { label: "ROUND", value: "ROUND", isAdv: true },
      ],
      [{ label: "NUMBER", value: "NUMBER", isAdv: true }],
    ],
  };

  const frequencyToKey = {
    "30 Seconds": "30SEC",
    "1 Minute": "1MIN",
    "5 Minutes": "5MIN",
    "15 Minutes": "15MIN",
    "30 Minutes": "30MIN",
    "1 Hour": "1HR",
    "2 Hours": "2HR",
    "4 Hours": "4HR",
    "8 Hours": "8HR",
    "1 Day": "1DAY",
    "1 Week": "1WEEK",
    "1 Month": "1MONTH",
    "1 Year": "1YEAR",
  };

  const [formula, setFormula] = useState({
    Formula: "",
    Operation: "",
    Operands: [],
  });
  const [subFormula, setSubFormula] = useState([]);
  const [advFormSelected, setAdvFormSelected] = useState(null);
  const [checkResult, setCheckResult] = useState(null);
  const [formulaCommitted, setFormulaCommitted] = useState(false);

  useEffect(() => {
    if (selectedTag !== null) {
      let temp = currStorage.map((item) => {
        const key = Object.keys(item)[0];
        return keyToFrequency[key] || key;
      });

      temp.push("Select Frequency");
      // Get frequencies that are NOT used yet (available options)
      const available = frequencyList.filter((freq) => !temp.includes(freq));

      console.log("dis456677", temp, frequencyList, available);
      setDisabledFrequency(available);
      setFrequencyOption(temp[0] || "Select Frequency");
    }
  }, [selectedTag]);

  useEffect(() => {
    if (
      frequencyOption &&
      frequencyOption !== "Select Frequency" &&
      currStorage
    ) {
      // Reverse mapping: frequency display name to key

      // Get the key from frequency display name
      const key = frequencyToKey[frequencyOption];

      // Find the object in currStorage
      const storageObject = currStorage.find(
        (item) => Object.keys(item)[0] === key,
      );

      console.log("Selected storage object:", storageObject);

      // You can now use the object
      if (storageObject) {
        const objectKey = Object.keys(storageObject)[0];
        const objectValue = storageObject[objectKey];
        console.log("Key:", objectKey, "Value:", objectValue);

        const available = [
          "SUM",
          "DIFF",
          "AVG",
          "MAX",
          "MIN",
          "SVAL",
          "EVAL",
        ].filter((freq) => !objectValue.includes(freq));
        setDisabledAggregation(available);

        // Do whatever you need with the object
        // e.g., setSelectedStorage(storageObject);
      }
    } else {
      setDisabledAggregation([
        "SUM",
        "DIFF",
        "AVG",
        "MAX",
        "MIN",
        "SVAL",
        "EVAL",
      ]);
    }
  }, [frequencyOption, currStorage]);

  const [num, setNum] = useState(null);
  const [subOperands, setSubOperands] = useState([]);

  const handleDone = () => {
    if (advFormSelected === "NUMBER") {
      if (num === null || num === "" || isNaN(num)) {
        // Don't commit empty number
        return;
      }
      setFormula((prev) => ({
        ...prev,
        Formula: prev.Formula + num,
      }));
      setNum(null);
      setAdvFormSelected(null);
      setSubFormula([]);
      return;
    } else {
      const newChunk = `${advFormSelected}(${subFormula.join(",")})`;

      if (operatorOption === "Standard") {
        // Standard: set Operation and build full formula
        setFormula((prev) => ({
          ...prev,
          Operation: advFormSelected,
          Formula: prev.Formula ? prev.Formula + newChunk : newChunk,
          Operands: [...(prev.Operands || []), ...subOperands], // ← use tracked operands directly
        }));
        setFormulaCommitted(true);
      } else {
        // Custom adv chip: append chunk to Formula, commit subOperands
        setFormula((prev) => ({
          ...prev,
          Formula: prev.Formula ? prev.Formula + newChunk : newChunk,
          Operands: [...(prev.Operands || []), ...subOperands], // ← add this
        }));
      }
    }
    setAdvFormSelected(null);
    setSubFormula([]);
    setSubOperands([]);
  };

  const onSelect = (selectedKeys, info) => {
    console.log("selected", selectedKeys, info);
  };

  const onCheck = (checkedKeys, info) => {
    console.log("onCheck", checkedKeys, info);
    // Only keep the most recently checked item
    if (info.checked) {
      setSelectedTag(info.node.key);
    } else {
      setSelectedTag(null);
    }
  };

  // Inline CSS
  const styles = `
    .ant-tree-treenode {
      width: 100%;
    }

    .ant-tree-node-content-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
    }

    .node-actions {
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
    }

    .ant-tree-node-content-wrapper:hover .node-actions {
      opacity: 1;
    }

    .ant-tree-list-holder-inner {
      height: 300px;
    }
  `;

  // Helper function to find node by key
  const findNodeByKey = (nodes, targetKey) => {
    for (const node of nodes) {
      if (node.key === targetKey) {
        return node;
      }
      if (node.children) {
        const found = findNodeByKey(node.children, targetKey);
        if (found) return found;
      }
    }
    return null;
  };

  // Helper function to find the parent of a node by key
  const findParentNode = (nodes, targetKey, parent = null) => {
    for (const node of nodes) {
      if (node.key === targetKey) {
        return parent;
      }
      if (node.children) {
        const found = findParentNode(node.children, targetKey, node);
        if (found !== undefined) return found;
      }
    }
    return undefined;
  };

  // Helper to create node titles with right-aligned icons
  const renderTitle = (title, type, key, node) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          color: themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
        }}
      >
        {/* Left side: title with icon */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {type === "tag" ? (
            <CustomCheckbox
              checked={selectedTag === key}
              onChange={(checked) => {
                if (checked) {
                  setSelectedTag(key);
                  setCurrStorage(node.storage);
                } else {
                  setSelectedTag(null);
                  setCurrStorage(null);
                }
              }}
            />
          ) : (
            <></>
          )}
          <span
            style={{ color: themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B" }}
          >
            {title}
          </span>
        </div>

        {/* Right side: action icons */}
        <div
          className="node-actions"
          style={{
            display: "flex",
            gap: 8,
            marginLeft: "16px",
          }}
        >
          {/* {type === "tag" && (
            <PlusOutlined
              style={{ color: "#008cd7", cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                // Removed the formula adding logic from here
                console.log("Add child to", key);
              }}
            />
          )} */}
        </div>
      </div>
    );
  };

  // Helper to process tree data and add renderTitle with node context
  const processTreeData = (nodes) => {
    return nodes.map((node) => {
      const processedNode = {
        ...node,
        title: renderTitle(node.title || node.key, node.type, node.key, node),
        children: node.children ? processTreeData(node.children) : undefined,
      };
      return processedNode;
    });
  };

  const [formulaView, setFormulaView] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === "closeButton") {
      setFormulaView(false);
    }
  };

  const canAdd = (() => {
    if (operatorOption === "Standard") {
      if (advFormSelected === null) return false;
      const rule = operandRules[advFormSelected];
      if (rule && subFormula.length >= rule.max) return false;
    }

    if (operatorOption === "Custom") {
      // Block + if NUMBER chip is active — only numbers allowed there
      if (advFormSelected === "NUMBER") return false;
    }

    // Tag must always be selected
    if (selectedTag === null) return false;

    // Historical: frequency and aggregation both required
    if (tagType === "1") {
      if (!frequencyOption || frequencyOption === "Select Frequency")
        return false;
      if (!aggregationOption) return false;
    }

    return true;
  })();

  const validateAdvFunctions = (formulaStr) => {
    let i = 0;
    const errors = [];

    while (i < formulaStr.length) {
      const funcMatch = formulaStr.slice(i).match(/^([A-Z][A-Z0-9]*)\(/);
      if (funcMatch) {
        const funcName = funcMatch[1];
        const openParenPos = i + funcMatch[1].length;

        let depth = 1;
        let j = openParenPos + 1;
        while (j < formulaStr.length && depth > 0) {
          if (formulaStr[j] === "(") depth++;
          else if (formulaStr[j] === ")") depth--;
          j++;
        }

        if (depth !== 0) {
          errors.push(`${funcName}: unclosed parenthesis.`);
          i++;
          continue;
        }

        const content = formulaStr.slice(openParenPos + 1, j - 1).trim();
        let argCount = content.length === 0 ? 0 : 1;
        let nestedDepth = 0;
        for (const ch of content) {
          if (ch === "(") nestedDepth++;
          else if (ch === ")") nestedDepth--;
          else if (ch === "," && nestedDepth === 0) argCount++;
        }

        const rule = operandRules[funcName];
        if (rule) {
          if (argCount < rule.min) {
            errors.push(
              `${funcName} requires at least ${rule.min} argument${rule.min > 1 ? "s" : ""} but got ${argCount}.`,
            );
          } else if (isFinite(rule.max) && argCount > rule.max) {
            errors.push(
              `${funcName} allows at most ${rule.max} argument${rule.max > 1 ? "s" : ""} but got ${argCount}.`,
            );
          }
        }

        i = openParenPos + 1;
      } else {
        i++;
      }
    }

    return errors;
  };

  useEffect(() => {
    setCheckResult(null);
  }, [formula, subFormula, advFormSelected]);

  useEffect(() => {
    if (virtualDevice === "true") {
      _setMaintabs(["Parameter List"]);
    } else {
      _setMaintabs(Maintablist);
    }
  }, [virtualDevice]);

  const defaultColumns = [
    {
      title: "Virtual",
      dataIndex: "isVirtual",
      width: "3.9%",
      render: (_text, record, index) => {
        const editable = isEditing(record);
        function handleIsVirtualCheck(selected) {
          console.log("handleIsVirtualCheck called", selected, typeof selected);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          let temp = [...editRow];
          temp[0].isVirtual = selected.toString();
          setEditRow(temp);
        }
        return (
          <CustomCheckbox
            defaultChecked={
              editable
                ? virtualDevice === "true"
                  ? true
                  : editRow[0].isVirtual
                : virtualDevice === "true"
                  ? true
                  : record.isVirtual
            }
            disabled={
              editable ? (virtualDevice === "true" ? true : false) : true
            }
            onChange={handleIsVirtualCheck}
          />
        );
      },
    },
    {
      title: "Parameter",
      dataIndex: "parameter",
      width: "13.4%",
      // editable: true,
      // render:(text,record,index)=>{
      //   return(
      //     <CustomDropDown data={list} selected={handleSelectedParameter} defaultValue={list[0]}/>
      //   )
      // }
      render: (_, record, index) => {
        const editable = isEditing(record);
        function handleParameterName(selected) {
          // dataSource.
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].parameter = selected.toString();

          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          editRow[0].parameter = selected.toString();
          setEditRow(editRow);
        }
        return editable ? (
          <>
            <CustomTextField
              prefix={
                virtualDevice === "true" ||
                editRow[0].isVirtual === "true" ||
                editRow[0].isVirtual === true
                  ? "vt-"
                  : ""
              }
              maxLength={250}
              onChange={handleParameterName}
              defaultValue={editRow[0].parameter}
              permittedCharacters={"^[a-zA-Z][a-zA-Z0-9_]*$"}
              errorText={"Only alphanumeric characters are allowed"}
              width={180}
            />
            <span style={{ color: "red", marginLeft: "5px" }}>*</span>
          </>
        ) : (
          <Typography>
            {virtualDevice === "true" ||
            record.isVirtual === "true" ||
            record.isVirtual === true
              ? "vt- " + record.parameter
              : record.parameter}
          </Typography>
        );
      },
    },
    {
      title: "Description",
      width: "16%",
      dataIndex: "description",
      // editable: true,
      render: (_, record, index) => {
        const editable = isEditing(record);
        function handleDescription(selected) {
          // dataSource.
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].description = selected.toString();
          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          editRow[0].description = selected.toString();
          setEditRow(editRow);
        }
        return editable ? (
          <>
            <CustomTextField
              prefix={
                virtualDevice === "true" ||
                editRow[0].isVirtual === "true" ||
                editRow[0].isVirtual === true
                  ? "vt-"
                  : ""
              }
              maxLength={250}
              onChange={handleDescription}
              defaultValue={editRow[0].description}
              width={220}
            />
            <span style={{ color: "red", marginLeft: "5px" }}>*</span>
          </>
        ) : (
          <Typography>
            {virtualDevice === "true" ||
            record.isVirtual === "true" ||
            record.isVirtual === true
              ? "vt- " + record.description
              : record.description}
          </Typography>
        );
      },
    },
    {
      title: "Alias",
      dataIndex: "alias",
      width: "8.5%",
      // editable: true,
      render: (_, record, index) => {
        const editable = isEditing(record);
        function handleAlias(selected) {
          // dataSource.
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].alias = selected.toString();
          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          editRow[0].alias = selected.toString();
          setEditRow(editRow);
        }
        return editable ? (
          <CustomTextField
            prefix={
              virtualDevice === "true" ||
              editRow[0].isVirtual === "true" ||
              editRow[0].isVirtual === true
                ? "vt-"
                : ""
            }
            maxLength={250}
            onChange={handleAlias}
            defaultValue={editRow[0].alias}
            permittedCharacters={"^[a-zA-Z][a-zA-Z0-9_]*$"}
            errorText={"Only alphanumeric characters are allowed"}
            width={120}
          />
        ) : (
          <Typography>
            {virtualDevice === "true" ||
            record.isVirtual === "true" ||
            record.isVirtual === true
              ? "vt- " + record.alias
              : record.alias}
          </Typography>
        );
      },
    },
    {
      title: "Data Type",
      dataIndex: "datatype",
      width: "9.5%",
      // editable: true,
      render: (_, record, index) => {
        const editable = isEditing(record);
        function handleDataTypeChange(selected) {
          // dataSource.
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].datatype = selected.toString();
          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          dataTypesList[1].forEach((item, index) => {
            if (item === selected) {
              editRow[0].datatype = dataTypesList[0][index];
            }
          });
          // editRow[0].datatype = selected.toString();
          setEditRow(editRow);
        }

        function handleDataTypeName(selected) {
          let name = "";
          dataTypesList[0].forEach((item, index) => {
            if (item === selected) {
              name = dataTypesList[1][index];
            }
          });
          return name;
        }

        return editable ? (
          <>
            <CustomDropDown
              options={dataTypesList[1]}
              onChange={handleDataTypeChange}
              defaultValue={handleDataTypeName(editRow[0].datatype)}
              width={"120px"}
            ></CustomDropDown>
            <span style={{ color: "red", marginLeft: "5px" }}>*</span>
          </>
        ) : (
          <Typography>{handleDataTypeName(record.datatype)}</Typography>
        );
      },
    },
    // {
    //   title: 'Value',
    //   dataIndex: 'value',
    //   editable: true,
    // },
    // {
    //   title: 'Timestamp',
    //   dataIndex: 'timestamp',
    //   editable: true,
    // },\
    {
      title: virtualDevice === "true" ? "Formula" : "Payload/Formula",
      dataIndex: "payloadName",
      width: "13.4%",
      // editable: true,
      render: (_, record, index) => {
        console.log("newdata777888", record);
        const editable = isEditing(record);
        function handlePayloadName(selected) {
          // dataSource.
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].payloadName = selected.toString();
          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          editRow[0].payloadName = selected.toString();
          setEditRow(editRow);
        }
        function handleFormula(selected) {
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          editRow[0].payloadName = null;
          editRow[0].formula.Formula = selected.toString();
          setEditRow(editRow);
        }

        return editable ? (
          virtualDevice === "true" ||
          editRow[0].isVirtual === "true" ||
          editRow[0].isVirtual === true ? (
            <>
              <CustomTextField
                disabled={true}
                maxLength={255}
                onChange={handleFormula}
                defaultValue={editRow[0].formula.Formula}
                permittedCharacters={"^[a-zA-Z][a-zA-Z0-9_\\.]*$"}
                errorText={"Only alphanumeric characters are allowed"}
                width={"140"}
              />
              <span
                style={{ color: "red", marginLeft: "5px", marginRight: "8px" }}
              >
                *
              </span>
              <Typography.Link
                style={{ color: "var(--LK_BrandBlue_1)" }}
                onClick={() => {
                  setFormulaView(true);
                  const hasExisting =
                    editRow[0].formula?.Formula &&
                    editRow[0].formula.Formula.trim() !== "";

                  // Restore operator mode based on saved Operation field
                  if (hasExisting) {
                    const savedOperation = editRow[0].formula.Operation;
                    const isCustom = savedOperation === "Formula";
                    setOperatorOption(isCustom ? "Custom" : "Standard");
                  } else {
                    setOperatorOption("Standard"); // default for new formula
                  }

                  setFormulaCommitted(hasExisting);
                  setFormula(
                    hasExisting
                      ? { ...editRow[0].formula }
                      : { Operation: "", Formula: "", Operands: [] },
                  );
                  setAdvFormSelected(null);
                  setSubFormula([]);
                  setSubOperands([]);
                  setCheckResult(null);
                  setTagType("0"); // reset to Live
                  setSelectedTag(null); // clear tag selection
                  setFrequencyOption("Select Frequency"); // reset frequency
                  setAggregationOption(null); // reset aggregation
                }}
              >
                Add
              </Typography.Link>
            </>
          ) : (
            <>
              <CustomTextField
                maxLength={250}
                onChange={handlePayloadName}
                defaultValue={editRow[0].payloadName}
                permittedCharacters={"^[a-zA-Z][a-zA-Z0-9_\\.]*$"}
                errorText={"Only alphanumeric characters are allowed"}
                width={"130"}
              />
              <span style={{ color: "red", marginLeft: "5px" }}>*</span>
            </>
          )
        ) : (
          <Typography>
            {record.isVirtual === "true" || record.isVirtual === true
              ? record.formula.Formula
              : record.payloadName}
          </Typography>
        );
      },
    },
    {
      title: "Unit",
      dataIndex: "unit",
      width: "8.2%",
      // editable: true,
      render: (_, record, index) => {
        const editable = isEditing(record);
        function handleUnitChange(selected) {
          // dataSource.
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].unit = selected.toString();
          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          if (selected === "NA") {
            editRow[0].unit = " ";
          } else {
            editRow[0].unit = selected.toString();
          }
          setEditRow(editRow);
        }

        return editable ? (
          <>
            <CustomDropDown
              options={unitsList}
              onChange={handleUnitChange}
              defaultValue={editRow[0].unit === " " ? "NA" : editRow[0].unit}
              width={"100px"}
            ></CustomDropDown>
            <span style={{ color: "red", marginLeft: "5px" }}>*</span>
          </>
        ) : (
          <Typography>{record.unit === " " ? "NA" : record.unit}</Typography>
        );
      },
    },
    {
      title: "Scaling Factor",
      dataIndex: "scalingFactor",
      width: "8%",
      // editable: true,
      render: (_text, record, index) => {
        const editable = isEditing(record);

        function handleScalingFactor(selected) {
          editRow[0].scalingFactor = selected;
          setEditRow(editRow);
        }

        return (
          <Box sx={{ display: "flex", flexDirection: "row", gap: "12px" }}>
            {editable ? (
              <>
                <CustomTextField
                  maxLength={250}
                  onChange={handleScalingFactor}
                  defaultValue={editRow[0].scalingFactor}
                  permittedCharacters={"^[0-9][0-9\\.]*$"}
                  errorText={"Only numeric characters are allowed"}
                  width={"100px"}
                />
              </>
            ) : (
              <Typography>{record.scalingFactor}</Typography>
            )}
          </Box>
        );
      },
    },
    {
      title: "Storage",
      dataIndex: "storage",
      width: "9%",
      // editable: true,
      render: (_text, record, index) => {
        const editable = isEditing(record);
        function handleStorageCheck(selected) {
          // dataSource.
          // if(selected==true){
          //   setifStorage(1);
          //   setStorageIndex(index);
          // }
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].storage = selected.toString();
          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          let temp = [...editRow];
          temp[0].storage = selected.toString();
          setEditRow(temp);
          // if(selected===true){
          //   setifStorage(1);
          //   setStorageIndex(index);
          // }
        }

        function handleStorageGroupChange(selected) {
          if (selected !== "none") {
            let opt = handleStorageGroupOptions(storageGroups);
            let index = opt.indexOf(selected);
            // let id = storageGroupsList.filter(item => item.GroupName === selected)
            let id = [];
            if (index !== -1) {
              id = storageGroupsList[index - 1];
            }
            if (id.length === 0) {
              editRow[0].storageGroupid = "";
            } else {
              editRow[0].storageGroupid = id.GroupID;
            }
          } else {
            editRow[0].storageGroupid = "";
          }
          setEditRow(editRow);
        }

        function handleStorageGroupIDtoName(selected) {
          if (selected === "") {
            return "none";
          } else {
            let id = storageGroupsList.filter(
              (item) => item.GroupID === selected,
            );
            if (id.length === 0) {
              return "";
            } else {
              let val = id[0].GroupName;
              if (val.charAt(0) === "_") {
                val = val.substring(1);
              }
              return val;
            }
          }
        }

        function handleStorageGroupOptions(data) {
          let opt = [];
          data.map((val) => {
            if (val.charAt(0) === "_") {
              val = val.substring(1);
            }
            opt.push(val);
          });
          return opt;
        }

        return (
          <Box sx={{ display: "flex", flexDirection: "row", gap: "12px" }}>
            <CustomCheckbox
              defaultChecked={editable ? editRow[0].storage : record.storage}
              disabled={editable ? false : true}
              onChange={handleStorageCheck}
            />
            {editable ? (
              <>
                <CustomDropDown
                  options={handleStorageGroupOptions(storageGroups)}
                  disabled={
                    editRow[0].storage.toString() === "true" ? false : true
                  }
                  onChange={handleStorageGroupChange}
                  defaultValue={handleStorageGroupIDtoName(
                    editRow[0].storageGroupid,
                  )}
                  width={"100px"}
                ></CustomDropDown>
              </>
            ) : (
              <Typography>
                {handleStorageGroupIDtoName(record.storageGroupid)}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      title: "Enable",
      dataIndex: "active",
      width: "3.8%",
      // editable: true,
      render: (_text, record, index) => {
        const editable = isEditing(record);
        function handleActiveCheck(selected) {
          // dataSource.
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].active = selected.toString();
          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          editRow[0].active = selected.toString();
          setEditRow(editRow);
        }
        return (
          <CustomCheckbox
            defaultChecked={editable ? editRow[0].active : record.active}
            disabled={editable ? false : true}
            onChange={handleActiveCheck}
          />
        );
      },
    },
    {
      title: "Operation",
      dataIndex: "operation",
      width: "6.3%",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.key)}
              style={{
                marginInlineEnd: 8,
                color: "var(--LK_BrandBlue_1)",
              }}
            >
              Done
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
        ) : (
          <Typography.Link
            style={{
              color:
                editingKey !== ""
                  ? "var(--Searchtext_muted)"
                  : "var(--LK_BrandBlue_1)",
            }}
            disabled={editingKey !== ""}
            onClick={() => edit(record)}
          >
            Edit
          </Typography.Link>
        );
      },
    },
  ];

  const liveDataCloumns = [
    {
      title: "Parameter",
      dataIndex: "parameter",
      width: "16%",
      editable: true,
      // render:(text,record,index)=>{
      //   return(
      //     <CustomDropDown data={list} selected={handleSelectedParameter} defaultValue={list[0]}/>
      //   )
      // }
    },
    {
      title: "Description",
      width: "20%",
      dataIndex: "description",
      editable: true,
    },
    {
      title: "Alias",
      dataIndex: "alias",
      width: "15%",
      editable: true,
    },
    {
      title: "Value",
      dataIndex: "value",
      editable: true,
    },
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      editable: true,
    },
    {
      title: "Unit",
      dataIndex: "unit",
      editable: true,
    },
  ];

  const [columnData, setColumnData] = useState(defaultColumns);

  function getParametrs(data) {
    if (tabvalue === "Parameter List") {
      setColumnData(JSON.parse(JSON.stringify(defaultColumns)));
      const paralist = JSON.parse(JSON.stringify(data));
      setActiveParameter(paralist);
    } else {
      setColumnData(liveDataCloumns);
      let temp = [];
      data.map((value) => {
        if (value.active === "true" || value.active === true) {
          temp = [...temp, value];
        }
      });
      setActiveParameter(temp);
    }
  }

  useEffect(() => {
    const newdata = [...dataSource];
    console.log("datasource", dataSource);
    console.log("newdata777", newdata);
    setdata(newdata);
    getParametrs(newdata);
    if (deleteTags === 1) {
      getdeleteTags(newdata);
      setdeleteTags(0);
    }
  }, [dataSource]);

  const handletabchange = (_event, newValue) => {
    setTabvalue(newValue);
  };

  useEffect(() => {
    getParametrs(dataSource);
  }, [tabvalue]);

  const edit = (record) => {
    form.setFieldsValue({
      name: "",
      age: "",
      address: "",
      ...record,
    });
    setEditingKey(record.key);
    setEditRow([{ ...record }]);
  };

  const cancel = () => {
    setEditingKey("");
    setEditRow([
      {
        tagId: "",
        key: 0,
        parameter: "",
        datatype: dataTypesList[0][0],
        description: "",
        alias: "",
        unit: unit0,
        payloadName: "",
        formula: {
          Operation: "",
          Formula: "",
          Operands: [],
        },
        value: "",
        timestamp: "",
        active: false,
        storage: false,
        storageGroupid: "",
        scalingFactor: "",
      },
    ]);
    const newData = [...dataSource];
    if (newData[newData.length - 1].key === editingKey) {
      if (
        newData[newData.length - 1].tagId === "" &&
        newData[newData.length - 1].parameter === ""
      ) {
        newData.pop();
        setDataSource(newData);
      }
    }
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item.key);
      const isVirtual =
        editRow[0].isVirtual === true || editRow[0].isVirtual === "true";

      const hasPayload = isVirtual
        ? editRow[0].formula?.Formula &&
          editRow[0].formula.Formula.trim() !== ""
        : editRow[0].payloadName !== "";

      if (
        editRow[0].parameter !== "" &&
        editRow[0].description !== "" &&
        hasPayload
      ) {
        if (index > -1) {
          const item = newData[index];
          newData.splice(index, 1, {
            ...item,
            ...editRow[0],
          });
          setDataSource(newData);
          setEditingKey("");
        } else {
          newData.push(editRow[0]);
          setDataSource(newData);
          setEditingKey("");
        }
        setEditRow([
          {
            tagId: "",
            key: 0,
            parameter: "",
            datatype: dataTypesList[0][0],
            description: "",
            alias: "",
            unit: unit0,
            payloadName: "",
            formula: {
              Operation: "",
              Formula: "",
              Operands: [],
            },
            value: "",
            timestamp: "",
            active: false,
            storage: false,
            storageGroupid: "",
            scalingFactor: "",
          },
        ]);
      } else {
        setRequired(1);
      }
    } catch (errInfo) {}
  };

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    _record,
    _index,
    children,
    ...restProps
  }) => {
    const inputNode = inputType === "number" ? <InputNumber /> : <Input />;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Please Input ${title}!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleDelete = () => {
    // let newData2 = [...deleteTags]
    let newData2 = [];
    let temp = [];
    {
      rowSelection.selectedRowKeys.map((val) => {
        temp = dataSource.filter(
          (item) => item.key === val && item.tagId !== "",
        );
        if (temp.length !== 0) {
          newData2 = [...newData2, temp[0].tagId];
        }
      });
    }
    // setdeleteTags(newData2)
    if (deviceId === "") {
      tagdelcallback(newData2);
    } else {
      tagdelete(deviceId, newData2, tagdelcallback);
    }
  };

  function tagdelcallback(_res) {
    let newData = dataSource;
    {
      rowSelection.selectedRowKeys.map((val) => {
        newData = newData.filter((item) => item.key !== val);
      });
    }
    setOperation(0);
    setSelectedRowKeys([]);
    setdeleteTags(1);
    setDataSource(newData);
  }

  useEffect(() => {
    // getdeleteTags(deleteTags)
  }, [deleteTags]);

  const handleDeleteCancel = () => {
    setSelectedRowKeys([]);
    setOperation(0);
  };

  const handleAdd = () => {
    const count =
      dataSource.length !== 0
        ? parseInt(dataSource[dataSource.length - 1].key, 10) + 1
        : 0;
    const unit = unitsList[0] === "NA" ? " " : unitsList[0];
    const newData = {
      tagId: "",
      key: count,
      parameter: "",
      datatype: dataTypesList[0][0],
      description: "",
      alias: "",
      unit: unit,
      payloadName: "",
      formula: {
        Operation: "",
        Formula: "",
        Operands: [],
      },
      value: "",
      timestamp: "",
      active: false,
      storage: false,
      storageGroupid: "",
      isVirtual: virtualDevice === "true" ? true : false,
      scalingFactor: "",
    };
    form.setFieldsValue({
      tagId: "",
      key: count,
      parameter: "",
      datatype: "",
      description: "",
      alias: "",
      unit: "",
      payloadName: "",
      formula: {
        Operation: "",
        Formula: "",
        Operands: [],
      },
      value: "",
      timestamp: "",
      active: false,
      storage: false,
      storageGroupid: "",
      isVirtual: virtualDevice === "true" ? true : false,
      scalingFactor: "",
    });
    setDataSource([...dataSource, newData]);
    setEditingKey(newData.key);
    setEditRow([{ ...newData }]);
  };

  //(tabvalue === "Parameter List"?defaultColumns:liveDataCloumns)

  const mergedColumns = (
    tabvalue === "Parameter List" ? defaultColumns : liveDataCloumns
  ).map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        // inputType: col.dataIndex === 'age' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  function handleFilterSelected(selectedValue) {
    search.filterSelected = selectedValue;
    setSearch(search);
  }

  function handleSearchText(selectedValue) {
    search.searchText = selectedValue;
    setSearch(search);
  }

  function handleSearchCancel() {
    setSearch({ searchText: "", filterSelected: "" });
    setsearchList([]);
    setifSearching(0);
  }

  function handleSearchClick() {
    let temp = [];
    let templist = [...activeParameter];
    if (search.filterSelected !== "") {
      const filterVal = Object.entries(filterMap).find(([_key, value]) =>
        search.filterSelected.includes(value),
      );
      setifSearching(1);
      let val = "";
      if (search.filterSelected.includes("Enable")) {
        val = "true";
      } else if (search.filterSelected.includes("Disable")) {
        val = "false";
      }
      activeParameter.filter((value) => {
        Object.keys(value).forEach((key) => {
          if (key === filterVal[0] && value[key] === val) {
            temp = [...temp, value];
          }
        });
        templist = [...temp];
      });
    }
    if (search.searchText !== "") {
      setifSearching(1);
      temp = [];
      templist.filter((value) => {
        if (
          value.parameter
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.alias.toLowerCase().includes(search.searchText.toLowerCase()) ||
          value.description
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.unit.toLowerCase().includes(search.searchText.toLowerCase()) ||
          value.datatype
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.payloadName
            .toLowerCase()
            .includes(search.searchText.toLowerCase()) ||
          value.scalingFactor
            .toLowerCase()
            .includes(search.searchText.toLowerCase())
        ) {
          temp = [...temp, value];
        }
      });
    }
    setsearchList(temp);
  }

  function handleTimestamp(timeVal) {
    const date = new Date(timeVal * 1000);
    const month = date.getMonth() + 1;
    const timestamp =
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      "-" +
      (month > 9 ? month : "0" + month) +
      "-" +
      date.getFullYear() +
      " " +
      (date.getHours() > 9 ? date.getHours() : "0" + date.getHours()) +
      ":" +
      (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes()) +
      ":" +
      (date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds());
    return timestamp;
  }

  useEffect(() => {
    if (livedata.length !== 0 && tabvalue === "Live Data") {
      let parainfo = {},
        temp = [];
      activeParameter.map((dsval) => {
        parainfo = { ...dsval };
        // parainfo={...dsval,storageId:[...dsval.storageId],}
        livedata.map((val) => {
          if (dsval.active === "true" || dsval.active === true) {
            if (dsval.tagId === val.TagId) {
              parainfo = {
                ...dsval,
                value: val.value.toFixed(decimalPoints),
                timestamp: handleTimestamp(val.timestamp),
              };
              //parainfo={...dsval,storageId:[...dsval.storageId],value:val.value.toFixed(decimalPoints),timestamp:handleTimestamp(val.timestamp)};
            }
          }
        });
        temp = [...temp, parainfo];
      });
      setDataSource(temp);
    }
  }, [livedata, tabvalue]);

  function handleDisplayDataTypeName(selected) {
    let name = "";
    dataTypesList[0].forEach((item, index) => {
      if (item === selected) {
        name = dataTypesList[1][index];
      }
    });
    return name;
  }

  function handleInternalDataTypeName(selected) {
    let name = "";
    dataTypesList[1].forEach((item, index) => {
      if (item === selected) {
        name = dataTypesList[0][index];
      }
    });
    return name;
  }

  function handleImportData(data) {
    setifLoading(1);
    const headerList = [
      "Parameter",
      "Description",
      "Alias",
      "Data Type",
      "Payload Name",
      "Unit",
      "Scaling Factor",
      "Storage",
      "Storage Group",
      "Enable",
    ];
    const fieldList = [
      "parameter",
      "description",
      "alias",
      "datatype",
      "payloadName",
      "unit",
      "scalingFactor",
      "storage",
      "storageGroupid",
      "active",
    ];
    let newData = [...dataSource];
    data.map((val) => {
      let ifpresent = "";
      newData.map((value, ind) => {
        if (value.parameter === val.Parameter) {
          ifpresent = ind;
        }
      });
      if (ifpresent !== "") {
        for (let i = 0; i < headerList.length; i++) {
          const temp = { ...newData[ifpresent] };
          temp[fieldList[i]] = val[headerList[i]];
          if (headerList[i] === "Storage Group") {
            if (val[headerList[i]] !== "none") {
              let id = storageGroupsList.filter((item) =>
                item.GroupName.charAt(0) === "_"
                  ? item.GroupName.substring(1) === val[headerList[i]]
                  : item.GroupName === val[headerList[i]],
              );
              if (id.length === 0) {
                temp[fieldList[i]] = "";
              } else {
                temp[fieldList[i]] = id[0].GroupID;
              }
            } else {
              temp[fieldList[i]] = "";
            }
          }
          if (headerList[i] === "Storage" || headerList[i] === "Enable") {
            //temp[fieldList[i]]=val[headerList[i]]==="Enabled"?true:false;
            temp[fieldList[i]] =
              val[headerList[i]] === "Enabled" ? "true" : "false";
          }
          if (headerList[i] === "Unit") {
            temp[fieldList[i]] =
              val[headerList[i]] === "NA" ? " " : val[headerList[i]];
          }
          if (headerList[i] === "Data Type") {
            temp[fieldList[i]] = handleInternalDataTypeName(val[headerList[i]]);
          }
          console.log("temp", temp);
          newData[ifpresent] = { ...temp };
        }
      } else {
        const temp = {
          tagId: "",
          key: 0,
          parameter: "",
          description: "",
          payloadName: "",
          datatype: "",
          timestamp: "",
          alias: "",
          value: "",
          unit: "",
          active: false,
          storage: false,
          storageId: [],
          storageGroupid: "",
        };
        temp.key = newData.length;
        for (let i = 0; i < headerList.length; i++) {
          temp[fieldList[i]] = val[headerList[i]];
          if (headerList[i] === "Storage Group") {
            if (val[headerList[i]] !== "none") {
              let id = storageGroupsList.filter((item) =>
                item.GroupName.charAt(0) === "_"
                  ? item.GroupName.substring(1) === val[headerList[i]]
                  : item.GroupName === val[headerList[i]],
              );
              if (id.length === 0) {
                temp[fieldList[i]] = "";
              } else {
                temp[fieldList[i]] = id[0].GroupID;
              }
            } else {
              temp[fieldList[i]] = "";
            }
          }
          if (headerList[i] === "Storage" || headerList[i] === "Enable") {
            //temp[fieldList[i]]=val[headerList[i]]==="Enabled"?true:false;
            temp[fieldList[i]] =
              val[headerList[i]] === "Enabled" ? "true" : "false";
          }
          if (headerList[i] === "Unit") {
            temp[fieldList[i]] =
              val[headerList[i]] === "NA" ? " " : val[headerList[i]];
          }
          if (headerList[i] === "Data Type") {
            temp[fieldList[i]] = handleInternalDataTypeName(val[headerList[i]]);
          }
        }
        newData = [...newData, temp];
      }
    });
    setDataSource(newData);
    setifLoading(0);
  }

  function handleExportData(data) {
    let dataToExport = data.filter((val) => selectedRowKeys.includes(val.key));
    dataToExport = dataToExport.map((val) => {
      let temp = { ...val };
      if (val.storageGroupid === "") {
        temp.storageGroupid = "none";
      } else {
        let id = storageGroupsList.filter(
          (item) => item.GroupID === val.storageGroupid,
        );
        if (id.length === 0) {
          temp.storageGroupid = "none";
        } else {
          if (id[0].GroupName.charAt(0) === "_") {
            temp.storageGroupid = id[0].GroupName.substring(1);
          } else {
            temp.storageGroupid = id[0].GroupName;
          }
        }
      }
      temp.datatype = handleDisplayDataTypeName(val.datatype);
      temp.active =
        val.active === true || val.active === "true" ? "Enabled" : "Disabled";
      temp.storage =
        val.storage === true || val.storage === "true" ? "Enabled" : "Disabled";
      temp.unit = val.unit === " " ? "NA" : val.unit;
      console.log("export temp", temp);
      return temp;
    });
    return dataToExport;
  }

  return (
    <>
      <style>{styles}</style>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          boxSizing: "border-box",
          maxWidth: "100%",
        }}
      >
        <Tabs
          value={tabvalue}
          onChange={handletabchange}
          TabIndicatorProps={{ hidden: true }}
          sx={{
            "& .MuiTabs-indicator": {
              display: "none",
              height: "0px",
              borderRadius: "0px",
              backgroundColor: "var(--action-button-light)",
              borderBottom: "1px solid var(--SecondaryBackground)",
            },
            "& .Mui-selected": {
              color: "var(--LK_BrandBlue_1) !important",
              fontWeight: "700 !important",
              backgroundColor: "var(--SecondaryBackground)",
              borderTop: "1px solid var(--HighlightedText_Stroke)",
              borderLeft: "1px solid var(--HighlightedText_Stroke)",
              borderRight: "1px solid var(--HighlightedText_Stroke)",
              borderBottom: "1px solid var(--SecondaryBackground)",
            },
            "& .MuiTab-root": {
              padding: "8px 8px 6px 8px !important",
              margin: "0px !important",
              minWidth: "63px",
            },
            minHeight: "30px",
            marginBottom: "-1px",
          }}
        >
          {maintabs.map((tab) => {
            return (
              <Tab
                sx={{
                  minHeight: "30px",
                  height: "30px",
                }}
                style={{
                  color: "var(--GreyVariation_2)",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "16.75px",
                  textTransform: "capitalize",
                }}
                value={tab}
                label={tab}
              >
                {tab}
              </Tab>
            );
          })}
        </Tabs>
      </div>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: "var(--SecondaryBackground)",
          padding: "8px",
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
          border: "1px solid var(--HighlightedText_Stroke)",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            boxSizing: "border-box",
            maxWidth: "100%",
            gap: "16px",
          }}
        >
          <Box
            style={{ alignContent: "center" }}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              boxSizing: "border-box",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box sx={{ flexGrow: 1 }} />
            {tabvalue === "Parameter List" ? (
              <>
                <CustomExportButton
                  data={handleExportData(dataSource)}
                  fileName="myData.csv"
                  headerList={[
                    "Parameter",
                    "Description",
                    "Alias",
                    "Data Type",
                    "Payload Name",
                    "Unit",
                    "Scaling Factor",
                    "Storage",
                    "Storage Group",
                    "Enable",
                  ]}
                  fieldList={[
                    "parameter",
                    "description",
                    "alias",
                    "datatype",
                    "payloadName",
                    "unit",
                    "scalingFactor",
                    "storage",
                    "storageGroupid",
                    "active",
                  ]}
                />
                {/* <Button
                  onClick={handleAdd}        selectedRowKeys.map((val)=>{dataSource.filter
                  type="text"
                  style={{
                    marginBottom: "0px",
                    marginTop:"0px",
                    color:"#008CD7",
                    alignSelf:"center",
                    justifySelf:"end",
                    minWidth: "32px",
                    padding:0,
                  }}
                >
                  <LK_Export color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/>
                </Button> */}
                <CustomImportButton setData={handleImportData} />
                {/* <Button
                  onClick={handleAdd}
                  type="text"
                  style={{
                    marginBottom: "0px",
                    marginTop:"0px",
                    color:"#008CD7",
                    alignSelf:"center",
                    justifySelf:"end",
                    minWidth: "32px",
                    padding:0,
                  }}
                >
                  <LK_Import color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/>
                </Button> */}
                <CustomTooltip
                  title={"Add"}
                  offset={[30, -20]}
                  placement={"right-end"}
                >
                  <Button
                    onClick={handleAdd}
                    disabled={editingKey !== "" ? true : false}
                    type="text"
                    style={{
                      marginRight: "-4px",
                      marginBottom: "0px",
                      marginTop: "0px",
                      color: "#008CD7",
                      alignSelf: "center",
                      justifySelf: "end",
                      minWidth: "32px",
                      padding: 0,
                    }}
                  >
                    <LK_Add
                      color={
                        editingKey !== ""
                          ? theme === "light"
                            ? "#C1C1C1"
                            : "#3C3C3C"
                          : "var(--LK_BrandBlue)"
                      }
                      width={"28px"}
                      height={"28px"}
                    />
                  </Button>
                </CustomTooltip>
                {/* {hasSelected && operation==0? */}
                <CustomTooltip
                  title={"Delete"}
                  offset={[30, -20]}
                  placement={"right-end"}
                >
                  <Button
                    onClick={() =>
                      setOperation(
                        rowSelection.selectedRowKeys.length > 0 ? 1 : 2,
                      )
                    }
                    type="text"
                    style={{
                      marginRight: "0px",
                      marginBottom: 0,
                      color: "#008CD7",
                      padding: 0,
                      minWidth: "32px",
                    }}
                  >
                    <LK_Delete
                      color="var(--LK_BrandBlue)"
                      width={"36px"}
                      height={"36px"}
                    />
                  </Button>
                </CustomTooltip>
                {/* :
                  <></>
                } */}
                <CustomDialogBox
                  dialogTitle={"Delete Conformation"}
                  dialogText={
                    "Are you sure you want to delete " +
                    rowSelection.selectedRowKeys.length +
                    " tag" +
                    (rowSelection.selectedRowKeys.length > 1 ? "s" : "")
                  }
                  openDialog={operation === 1}
                  handleCloseDialog={handleDeleteCancel}
                  handleConfirmDialog={handleDelete}
                  confirmText={"Yes"}
                  cancelText={"No"}
                  type={"Warning"}
                />
                <CustomDialogBox
                  dialogTitle={"Delete Conformation"}
                  dialogText={"Please select devices for deletion"}
                  openDialog={operation === 2}
                  handleCloseDialog={handleDeleteCancel}
                  handleConfirmDialog={handleDeleteCancel}
                  confirmText={"OK"}
                  cancelText={"Cancel"}
                  type={"Warning"}
                />
                <CustomDialogBox
                  dialogTitle={"Required fields to be filled"}
                  dialogText={"Please fill required fields"}
                  openDialog={required === 1}
                  handleCloseDialog={() => setRequired(0)}
                  handleConfirmDialog={() => setRequired(0)}
                  confirmText={"OK"}
                  cancelText={"Cancel"}
                  type={"Warning"}
                />
              </>
            ) : (
              <></>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                width: "auto",
                fontSize: "16px",
                fontFamily: "Roboto",
                margin: "0px",
                alignSelf: "center",
                gap: "20px",
                alignItems: "center",
              }}
            >
              <CustomTextField
                id={"negative-feedback"}
                onChange={handleSearchText}
                defaultValue={ifsearching === 0 ? "" : search.searchText}
                placeholder={"search"}
                width={180}
              />
              <CustomDropDown
                options={filter}
                onChange={handleFilterSelected}
                defaultValue={ifsearching === 0 ? "" : search.filterSelected}
                width={"150px"}
              ></CustomDropDown>
              <CustomTooltip
                title={"Search"}
                offset={[30, -20]}
                placement={"right-end"}
              >
                <Button
                  onClick={handleSearchClick}
                  style={{
                    fontSize: "12px",
                    width: "40px",
                    fontWeight: 400,
                    color: "var(--Searchtext_muted)",
                    fontFamily: "Roboto",
                    textAlign: "left",
                    justifySelf: "right",
                    cursor: "pointer",
                    textTransform: "none",
                    marginLeft: "-24px",
                    padding: 0,
                  }}
                >
                  <LK_Search
                    color="var(--LK_BrandBlue)"
                    width={"28px"}
                    height={"28px"}
                  />
                </Button>
              </CustomTooltip>
              {ifsearching === 1 ? (
                <Button
                  onClick={handleSearchCancel}
                  style={{
                    fontSize: "12px",
                    width: "10px",
                    fontWeight: 400,
                    color: "var(--Searchtext_muted)",
                    fontFamily: "Roboto",
                    textAlign: "left",
                    justifySelf: "right",
                    cursor: "pointer",
                    textTransform: "none",
                    marginLeft: "-44px",
                    padding: 0,
                  }}
                >
                  <LK_Close
                    color="var(--LK_BrandBlue)"
                    width={"24px"}
                    height={"24px"}
                  />
                </Button>
              ) : (
                <></>
              )}
            </Box>
          </Box>
          <Form
            form={form}
            component={false}
            style={{ width: "100%", boxSizing: "border-box", maxWidth: "100%" }}
          >
            <ConfigProvider
              theme={{
                token: {
                  borderRadius: 0,
                  colorText: "var(--grey-variation-tablerowsLK)",
                  colorTextHeading: "var(--grey-variation-tablerowsLK)",
                  //fontFamily: props.widgetprop.props.extended.tablerows.fonttype,
                  fontSizeIcon: 10,
                  //colorBgContainer: '#EDEFEE',
                  lineHeight: 1.5,
                  boxSizing: "border-box",
                  // width:'100%',
                  // maxWidth:'100%'
                },
                components: {
                  Table: {
                    borderColor: "var(--table-boarder-line)",
                    headerBg: "var(--SecondaryBackground)",
                    headerSplitColor: "var(--SecondaryBackground)",
                    colorBgContainer: "var(--SecondaryBackground)",
                    rowHoverBg: "var(--primary-background-color-hover)",
                    stickyScrollBarBg:
                      "var(--primary-background-color),var(--secondary-background)",
                    stickyScrollBarBorderRadius: 0,
                    //cellFontSizeSM: props.widgetprop.props.extended.tablerows.fontsize,
                    cellPaddingBlockSM: "7.05px",
                    cellPaddingInlineSM: "7.1px",
                    width: "100%",
                    maxWidth: "100%",
                    boxSizing: "border-box",
                  },
                },
              }}
              style={{
                width: "100%",
                boxSizing: "border-box",
                maxWidth: "100%",
              }}
            >
              {console.log(
                "rendering table",
                ifsearching,
                searchList,
                activeParameter,
              )}

              <Table
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                rowSelection={rowSelection}
                bordered={false}
                tableLayout="fixed"
                size="small"
                pagination={false}
                style={{
                  marginLeft: "2px",
                  marginRight: "2px",
                  marginTop: 0,
                  marginBottom: 0,
                  //height: "200px",
                  // width: 'calc(100% - 4px)',
                  width: "99%",
                  maxWidth: "100%",
                  boxSizing: "border-box",
                  tableLayout: "fixed",
                  backgroundColor: "#EDEFEE",
                  boxSizing: "border-box",
                }}
                rowClassName={() => "editable-row"}
                dataSource={ifsearching === 0 ? activeParameter : searchList}
                columns={mergedColumns}
                scroll={{
                  y: "410px",
                }}
                notFoundContent={"No Data"}
                locale={{
                  emptyText: (
                    <span style={{ color: "var(--GreyBaseColor)" }}>
                      {" "}
                      {ifloading !== 1 ? (
                        <Typography
                          style={{
                            color: "var(--GreyBaseColor)",
                            fontSize: "44px",
                            fontFamily: "Roboto",
                            margin: "32px 0px",
                          }}
                        >
                          No Data
                        </Typography>
                      ) : (
                        <img
                          src={LK_Loading}
                          alt="loading..."
                          style={{
                            height: "64px",
                            width: "auto",
                            alignSelf: "center",
                            margin: "32px 0px",
                          }}
                        />
                      )}
                      {/* <Button>do something</Button> */}
                      {/* <img src="https://www.baidu.com/img/bd_logo1.png" /> */}
                    </span>
                  ),
                }}
              />
            </ConfigProvider>
          </Form>
          {/* <StorageForm  openDialog={ifstorage===1} dialogTitle={"Storage Form"} confirmText={"Save"} cancelText={"Cancel"}/> */}
        </Box>
        {
          <Dialog
            maxWidth={"xl"}
            open={formulaView}
            onClose={(event, reason) => {
              if (reason === "backdropClick" || reason === "escapeKeyDown") {
                event.preventDefault();
              } else {
                handleClose(event, reason);
              }
            }}
            aria-labelledby="responsive-dialog-title"
            PaperProps={{
              style: {
                backgroundColor:
                  themeOperate === "dark" ? "#000000" : "#EFEFEF",
                boxShadow: "none",
                borderRadius: "0px",
              },
            }}
            BackdropProps={{
              style: {
                backgroundColor:
                  themeOperate === "dark"
                    ? "rgba(255,255,255,0.7)"
                    : "rgba(0,0,0,0.7)",
              },
            }}
          >
            <DialogContent>
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: "10px",
                    alignItems: "center",
                  }}
                >
                  <MuiTypography
                    sx={{
                      color: themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
                      fontSize: "16px",
                      fontWeight: 700,
                    }}
                  >
                    Formula
                  </MuiTypography>
                  <div style={{ flexGrow: 1 }}> </div>

                  {checkResult !== null && (
                    <MuiTypography
                      style={{
                        fontSize: "13px",
                        fontFamily: "Roboto",
                        color: checkResult.valid ? "#00943d" : "#dc272d",
                        whiteSpace: "pre-line",
                      }}
                    >
                      {checkResult.message}
                    </MuiTypography>
                  )}
                  <div style={{ width: "8px" }}></div>
                  <CustomCancelButton
                    buttonText={"Cancel"}
                    onClick={(event) => handleClose(event, "closeButton")}
                  />
                  <div style={{ width: "8px" }}></div>
                  <CustomButton
                    buttonText={"Save"}
                    onClick={() => {
                      const updatedRow = [...editRow];
                      updatedRow[0].formula = {
                        Operation:
                          operatorOption === "Custom"
                            ? "FORMULA"
                            : formula.Operation,
                        Formula: formula.Formula,
                        Operands: formula.Operands,
                      };
                      setEditRow(updatedRow);
                      setFormulaView(false);
                    }}
                    disabled={checkResult === null || !checkResult.valid}
                  />
                </div>
                <div
                  style={{
                    width: "900px",
                    height: "600px",
                    backgroundColor:
                      themeOperate === "dark" ? "#1e1e1e" : "#FFFFFF",
                    padding: "16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "60%",
                      // backgroundColor:
                      //   themeOperate === "dark" ? "#000000" : "#EFEFEF",
                      // padding: "8px",
                      gap: "8px",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div
                      style={{
                        width: "calc(40% - 16px)",
                        height: "calc(100% - 16px)",
                        backgroundColor:
                          themeOperate === "dark" ? "#000000" : "#EFEFEF",
                        padding: "8px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        overflow: "hidden", // ← prevent the container itself from expanding
                      }}
                    >
                      <MuiTypography
                        sx={{
                          color:
                            themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
                          fontSize: "16px",
                          fontWeight: 700,
                          flexShrink: 0,
                          borderBottom:
                            themeOperate === "dark"
                              ? "1px solid #3c3c3c"
                              : "1px solid #c1c1c1",
                        }}
                      >
                        Tags
                      </MuiTypography>
                      <Tree
                        style={{
                          backgroundColor:
                            themeOperate === "dark" ? "#000000" : "#EFEFEF",
                          color:
                            themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
                        }}
                        switcherIcon={<DownOutlined />}
                        // onSelect={onSelect}
                        treeData={processTreeData(tagConfig)}
                      />
                      {/* </div> */}
                    </div>
                    <div
                      style={{
                        width: "calc(25% - 16px)",
                        height: "calc(100% - 16px)",
                        // backgroundColor:
                        //   themeOperate === "dark" ? "#000000" : "#EFEFEF",
                        padding: "8px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CustomButton
                        buttonText={"+"}
                        width={60}
                        disabled={!canAdd}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (selectedTag !== null) {
                            const selectedNode = findNodeByKey(
                              tagConfig,
                              selectedTag,
                            );
                            if (selectedNode) {
                              const parentNode = findParentNode(
                                tagConfig,
                                selectedTag,
                              );
                              const nodeLabel = parentNode
                                ? `${parentNode.title}.${selectedNode.title}`
                                : selectedNode.title;

                              const isHistorical = tagType === "1";
                              const freqKey = frequencyToKey[frequencyOption];
                              const variable = isHistorical
                                ? `${nodeLabel}.${freqKey}.${aggregationOption}`
                                : nodeLabel;

                              const newOperand = {
                                Variable: variable,
                                TagID: selectedTag,
                                Frequency: isHistorical ? freqKey : null,
                                Aggregation: isHistorical
                                  ? aggregationOption
                                  : null,
                              };

                              if (operatorOption === "Standard") {
                                setSubFormula([...subFormula, variable]);
                                setSubOperands([...subOperands, newOperand]); // ← track full operand alongside
                                // Operands tracked on Done, not here
                              } else {
                                if (advFormSelected !== null) {
                                  setSubFormula([...subFormula, variable]);
                                  setSubOperands([...subOperands, newOperand]); // ← add this
                                } else {
                                  setFormula((prev) => ({
                                    ...prev,
                                    Formula: prev.Formula + variable,
                                    Operands: [
                                      ...(prev.Operands || []),
                                      newOperand,
                                    ],
                                  }));
                                }
                              }
                            }
                          }
                        }}
                      />
                      <Radio.Group
                        onChange={(e) => {
                          setTagType(e.target.value);
                        }}
                        defaultValue={tagType}
                        buttonStyle="solid"
                      >
                        <Radio.Button value="0">Live</Radio.Button>
                        <Radio.Button value="1">Historical</Radio.Button>
                      </Radio.Group>
                      <div
                        style={{
                          visibility: tagType === "0" ? "hidden" : "visible",
                        }}
                      >
                        <CustomDropDown
                          disabledOptions={disabledFrequency}
                          options={[
                            "Select Frequency",
                            "30 Seconds",
                            "1 Minute",
                            "5 Minutes",
                            "15 Minutes",
                            "30 Minutes",
                            "1 Hour",
                            "2 Hours",
                            "4 Hours",
                            "8 Hours",
                            "1 Day",
                            "1 Week",
                            "1 Month",
                            "1 Year",
                          ]}
                          onChange={(val) => setFrequencyOption(val)}
                          defaultValue={frequencyOption}
                          width={180}
                        />
                      </div>
                      <div
                        style={{
                          width: "calc(100% - 40px)",
                          padding: "8px",
                          // height: "calc(80% - 64px)",
                          backgroundColor:
                            themeOperate === "dark" ? "#000000" : "#EFEFEF",
                          visibility: tagType === "0" ? "hidden" : "visible",
                        }}
                      >
                        <CustomRadioButton
                          disabledOptions={disabledAggregation}
                          row={true}
                          onChange={(val) =>
                            setAggregationOption(val.target.value)
                          }
                          options={[
                            ["SUM", "SUM"],
                            ["DIFF", "DIFF"],
                            ["AVG", "AVG"],
                            ["MAX", "MAX"],
                            ["MIN", "MIN"],
                            ["SVAL", "SVAL"],
                            ["EVAL", "EVAL"],
                          ]}
                          fontSize={14}
                          width={"100%"}
                          optionWidth={157}
                          defaultValue={
                            frequencyOption === "Select Frequency"
                              ? null
                              : aggregationOption
                          }
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        width: "calc(35% - 16px)",
                        height: "calc(100% - 16px)",
                        backgroundColor:
                          themeOperate === "dark" ? "#000000" : "#EFEFEF",
                        padding: "8px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <MuiTypography
                        sx={{
                          color:
                            themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
                          fontSize: "16px",
                          fontWeight: 700,
                          borderBottom:
                            themeOperate === "dark"
                              ? "1px solid #3c3c3c"
                              : "1px solid #c1c1c1",
                        }}
                      >
                        Operators
                      </MuiTypography>
                      <CustomDropDown
                        key={operatorOption}
                        options={["Standard", "Custom"]}
                        onChange={(val) => {
                          setOperatorOption(val);
                          if (val === "Custom") {
                            setFormula((prev) => ({
                              ...prev,
                              Operation: "FORMULA",
                            }));
                          } else {
                            setFormula((prev) => ({ ...prev, Operation: "" }));
                          }
                        }}
                        defaultValue={operatorOption}
                        width={294}
                        disabled={
                          formulaCommitted && operatorOption === "Standard"
                        }
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          marginTop: "16px",
                          overflow: "auto",
                          height: "calc(100% - 88px)",
                        }}
                      >
                        {operatorConfig[operatorOption].map((row, rowIndex) => (
                          <Box
                            key={rowIndex}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "8px",
                              justifyContent: "space-evenly",
                            }}
                          >
                            {row.map((op) => (
                              <CustomCancelButton
                                fontSize={13}
                                key={op.value}
                                buttonText={op.label}
                                onClick={() => {
                                  if (
                                    operatorOption === "Standard" &&
                                    op.isAdv
                                  ) {
                                    setAdvFormSelected(op.value);
                                  } else if (operatorOption === "Custom") {
                                    if (op.isAdv) {
                                      // Creates a chip (SQRT, ABS, SIN etc.) — tags added via + into subFormula
                                      setAdvFormSelected(op.value);
                                    } else {
                                      // Non-adv: +, -, *, /, %, ^, (, ) — append directly to FORMULA
                                      setFormula((prev) => ({
                                        ...prev,
                                        Formula: prev.Formula + op.value,
                                      }));
                                    }
                                  }
                                }}
                                disabled={
                                  (operatorOption === "Standard" &&
                                    advFormSelected !== null &&
                                    advFormSelected !== op.value) ||
                                  (operatorOption === "Standard" &&
                                    formulaCommitted)
                                }
                              />
                            ))}
                          </Box>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "calc(100% - 16px)",
                      height: "40%",
                      backgroundColor:
                        themeOperate === "dark" ? "#000000" : "#EFEFEF",
                      padding: "8px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <MuiTypography
                      sx={{
                        color: themeOperate === "dark" ? "#FFFFFF" : "#5B5B5B",
                        fontSize: "16px",
                        fontWeight: 700,
                        borderBottom:
                          themeOperate === "dark"
                            ? "1px solid #3c3c3c"
                            : "1px solid #c1c1c1",
                      }}
                    >
                      Formula
                    </MuiTypography>
                    <div
                      style={{
                        width: "calc(100% - 16px)",
                        height: "calc(70% - 16px)",
                        backgroundColor:
                          themeOperate === "dark" ? "#1e1e1e" : "#FFFFFF",
                        padding: "8px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                        maxWidth: "calc(100% - 16px)",
                      }}
                    >
                      {formula.Formula}
                      {advFormSelected !== null ? (
                        advFormSelected === "NUMBER" ? (
                          <div
                            style={{
                              fontSize: "13px",
                              backgroundColor:
                                themeOperate === "dark" ? "#000000" : "#EFEFEF",
                              padding: "8px 12px",
                              width: "140px",
                              borderRadius: "32px",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            NUMBER:{" "}
                            <CustomTextField
                              type={"number"}
                              onChange={(val) => setNum(val)}
                              fontSize={13}
                              width={30}
                            />{" "}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <DoneIcon fontSize="small" onClick={handleDone} />
                              <CloseIcon
                                fontSize="small"
                                onClick={() => {
                                  setAdvFormSelected(null);
                                  setSubFormula([]);
                                  setSubOperands([]);
                                  // Do NOT touch formula — only cancel what's being built
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <Chip
                            label={`${advFormSelected}(${subFormula.join(",")})`}
                            onDelete={() => {}}
                            deleteIcon={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <DoneIcon
                                  fontSize="small"
                                  onClick={handleDone}
                                />
                                <CloseIcon
                                  fontSize="small"
                                  onClick={() => {
                                    setAdvFormSelected(null);
                                    setSubFormula([]);
                                    setSubOperands([]);
                                    // Do NOT touch formula — only cancel what's being built
                                  }}
                                />
                              </div>
                            }
                          />
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                    <div
                      style={{
                        width: "100%",
                        height: "35px",
                        display: "flex",
                        flexDirection: "row-reverse",
                        gap: "8px",
                      }}
                    >
                      <CustomButton
                        buttonText={"Check"}
                        onClick={() => {
                          if (operatorOption === "Standard") {
                            if (formulaCommitted && advFormSelected === null) {
                              if (
                                !formula.Formula ||
                                formula.Formula.trim() === ""
                              ) {
                                setCheckResult({
                                  valid: false,
                                  message: "Formula is empty.",
                                });
                              } else {
                                const rule = operandRules[formula.Operation];
                                const count = formula.Operands.length;
                                if (rule && count < rule.min) {
                                  setCheckResult({
                                    valid: false,
                                    message: `${formula.Operation} requires at least ${rule.min} operand${rule.min > 1 ? "s" : ""}. You have ${count}.`,
                                  });
                                } else if (
                                  rule &&
                                  isFinite(rule.max) &&
                                  count > rule.max
                                ) {
                                  setCheckResult({
                                    valid: false,
                                    message: `${formula.Operation} allows at most ${rule.max} operand${rule.max > 1 ? "s" : ""}. You have ${count}.`,
                                  });
                                } else {
                                  setCheckResult({
                                    valid: true,
                                    message: "Formula is valid.",
                                  });
                                }
                              }
                            } else if (advFormSelected !== null) {
                              const rule = operandRules[advFormSelected];
                              const count = subFormula.length;
                              if (rule) {
                                if (count < rule.min) {
                                  setCheckResult({
                                    valid: false,
                                    message: `${advFormSelected} requires at least ${rule.min} operand${rule.min > 1 ? "s" : ""}. You have ${count}.`,
                                  });
                                } else if (count > rule.max) {
                                  setCheckResult({
                                    valid: false,
                                    message: `${advFormSelected} allows at most ${rule.max} operand${rule.max > 1 ? "s" : ""}. You have ${count}.`,
                                  });
                                } else {
                                  setCheckResult({
                                    valid: true,
                                    message: "Formula is valid.",
                                  });
                                }
                              }
                            } else {
                              setCheckResult({
                                valid: false,
                                message: "No operator selected.",
                              });
                            }
                          } else {
                            // Custom mode
                            if (
                              !formula.Formula ||
                              formula.Formula.trim() === ""
                            ) {
                              setCheckResult({
                                valid: false,
                                message: "Formula is empty.",
                              });
                              return;
                            }
                            if (advFormSelected !== null) {
                              setCheckResult({
                                valid: false,
                                message:
                                  "Complete or cancel the current operator chip before checking.",
                              });
                              return;
                            }

                            // Structural checks
                            const f = formula.Formula;

                            // Balanced parentheses
                            let depth = 0;
                            for (const ch of f) {
                              if (ch === "(") depth++;
                              else if (ch === ")") depth--;
                              if (depth < 0) {
                                setCheckResult({
                                  valid: false,
                                  message:
                                    "Unmatched closing parenthesis in formula.",
                                });
                                return;
                              }
                            }
                            if (depth !== 0) {
                              setCheckResult({
                                valid: false,
                                message: "Unclosed parenthesis in formula.",
                              });
                              return;
                            }

                            // Must not start or end with an operator
                            if (/^[+\-*/%^]/.test(f.trim())) {
                              setCheckResult({
                                valid: false,
                                message:
                                  "Formula cannot start with an operator.",
                              });
                              return;
                            }
                            if (/[+\-*/%^]$/.test(f.trim())) {
                              setCheckResult({
                                valid: false,
                                message: "Formula cannot end with an operator.",
                              });
                              return;
                            }

                            // No consecutive operators
                            if (/[+\-*/%^]{2,}/.test(f)) {
                              setCheckResult({
                                valid: false,
                                message:
                                  "Formula contains consecutive operators.",
                              });
                              return;
                            }

                            // Must have at least one tag operand
                            if (formula.Operands.length === 0) {
                              setCheckResult({
                                valid: false,
                                message:
                                  "Formula must reference at least one tag.",
                              });
                              return;
                            }

                            // Adv function argument count validation
                            const funcErrors = validateAdvFunctions(f);
                            if (funcErrors.length > 0) {
                              setCheckResult({
                                valid: false,
                                message: funcErrors.join("\n"),
                              });
                              return;
                            }

                            setCheckResult({
                              valid: true,
                              message: "Formula looks valid.",
                            });
                          }
                        }}
                      />
                      <CustomCancelButton
                        buttonText={"Clear"}
                        onClick={() => {
                          setFormula({
                            Operation: "",
                            Formula: "",
                            Operands: [],
                          });
                          setAdvFormSelected(null);
                          setSubFormula([]);
                          setFormulaCommitted(false); // ← unlock
                          setCheckResult(null);
                          setSubOperands([]);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </>
            </DialogContent>
          </Dialog>
        }
      </Box>
    </>
  );
}
